
export class PackCategory {
    constructor(public id: number, public label: string, public branchId: number) {
    }
}